module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/cloud-e1760f1d1ad40de9911625aa93fade15.svg";